import * as React from 'react';
import { t } from '@moovly/i18n';

import { ModalContainer } from '@moovly/ui';
import LibraryCreateUpdateContainer from '../containers/LibraryCreateUpdateContainer';
import { DefaultModalProps } from '../../../types/modal';

export const CreateLibraryModal: React.FC<DefaultModalProps> = ({ closeModal, setOpen }) => {
  return (
    <ModalContainer setOpen={setOpen} title={t('libraries.create.title')} canCancel={false}>
      <LibraryCreateUpdateContainer onClose={closeModal} />
    </ModalContainer>
  );
};

export default CreateLibraryModal;
